/*
 * Copied from: static_src/js/c2Archive/mixpanel.js
 * Global methods to bind events in our UI to report back to mixpanel
 */

(function (c2, $) {
  'use strict';


  function cleanurl(urlpath) {
    // remove all IDs from a URL
    return urlpath.replace(/\/\d+\//g, '/N/');
  }


  function init() {
    /*
     * Mixpanel client library defined as a global object window.mixpanel
     *
     * from https://mixpanel.com/help/reference/tracking-an-event#install-the-library
     */

    // The token was defined in c2.go()
    mixpanel.init(c2.settings.mixpanelToken);

    // report all clicks on the Help link to Mixpanel, including the current
    // page's path & hash (so we can see what page & tab the user was on when
    // they clicked Help)
    $('a.help-link').on('click', function (e) {
      mixpanel.track("Help clicked", {
        path: cleanurl(window.location.pathname),
        hash: window.location.hash,
        "id.license": window.c2.settings.CBLicenseID,
      });
    });
  }


  c2.mixpanel = {
    init: init
  };
})(window.c2, window.jQuery);
